import initAmbassadorSlider from "./init-ambassador-slider";
import initCategoriesSlider from "./init-categories-slider";
import initCooperationSlider from "./init-cooperation-slider";
import initDiplomSlider from "./init-diplom-slider";
import initEducationLargeSlider from "./init-education-large-slider";
import initEducationSlider from "./init-education-slider";
import initEducatorsSlider from "./init-educators-slider";
import initFaqSlider from "./init-faq-slider";
import initGraduatesSlider from "./init-graduates-slider";
import initHrReviewsSlider from "./init-hr-slider";
import initMediaSlider from "./init-media-slider";
import initPartnersSlider from "./init-partners-slider";
import initStoriesSlider from "./init-stories-slider";
import initTeachersSlider from "./init-teachers-slider";
import initTeamSlider from "./init-team-slider";
import initTrafficSlider from "./init-traffic-slider";
import initWebmastersSlider from "./init-webmasters-slider";
import initStatusSlider from "./init-status-slider";
import initHowTOGetSlider from "./init-how-to-get-slider";
import initDissmisalriskSlider from "./init-dissmisalrisk-slider";
import initResultCoopSlier from "./init-result-coop-slider";
import initReviewsPartnersSlier from "./init-reviews-partners-slider";
import initCommentsSlider from "./init-comments-slider";

const sliders = () => {
  initCooperationSlider();
  initStoriesSlider();
  initHrReviewsSlider();
  initTeamSlider();
  initPartnersSlider();
  initWebmastersSlider();
  initTrafficSlider();
  initGraduatesSlider();
  initEducatorsSlider();
  initMediaSlider();
  initCategoriesSlider();
  initEducationSlider();
  initEducationLargeSlider();
  initDiplomSlider();
  initFaqSlider();
  initAmbassadorSlider();
  initTeachersSlider();
  initStatusSlider();
  initHowTOGetSlider();
  initDissmisalriskSlider();
  initResultCoopSlier();
  initReviewsPartnersSlier();
  initCommentsSlider();
};

export default sliders;
